module.exports = __webpack_public_path__ + "img/logo-plano.e0ca9af7.png";